import { encode } from "uqr";
import { svg } from "./dom";

/**
 * Renders `text` as a QR code SVG (one path, one unit per module). Colors are fixed
 * dark-on-white regardless of theme: scanners need the contrast.
 */
export function qrSvg(text: string, label: string): SVGSVGElement {
  const { data, size } = encode(text, { ecc: "M", border: 2 });
  let d = "";
  data.forEach((row, y) => {
    row.forEach((dark, x) => {
      if (dark) d += `M${x} ${y}h1v1h-1z`;
    });
  });

  const el = svg("svg", {
    viewBox: `0 0 ${size} ${size}`,
    role: "img",
    "aria-label": label,
    "shape-rendering": "crispEdges",
    class: "qr",
  });
  el.append(svg("rect", { width: size, height: size, fill: "#ffffff" }), svg("path", { d, fill: "#111111" }));
  return el;
}
